import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4aa1458f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "invite-box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "推广服务", -1));
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 案例 ");
const _hoisted_4 = {
  key: 1,
  style: {
    "height": "15px"
  }
};
const _hoisted_5 = {
  class: "content"
};
const _hoisted_6 = {
  class: "gold-info"
};
const _hoisted_7 = {
  class: "gold-num-info"
};
const _hoisted_8 = /*#__PURE__*/_createTextVNode("金币");
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 任务中心 ");
const _hoisted_10 = {
  class: "tab-info",
  style: {
    "background-color": "#FFFFFF"
  }
};
const _hoisted_11 = {
  class: "tab-header"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  key: 0,
  class: "tab-item-indicator"
};
import { env } from "md-base-tools/env";
import domain from "@/service/domain";
import router from '@/router';
import { onMounted, reactive, ref } from "vue";
import allList from '@@/promotion/promotionAllList.vue';
import myList from '@@/promotion/promotionMyList.vue';
import { useRoute } from 'vue-router';
import { getGoldNum } from "@/api";
export default {
  setup(__props) {
    const tabTitles = [{
      title: '推广服务',
      index: 0
    }, {
      title: '我的推广',
      index: 1
    }];
    const tab_index = ref(0);
    const tabStyle = reactive({
      tabsLineHeight: '0'
    });
    const isFix = ref(0);
    const allListRef = ref(null);
    const myListRef = ref(null);
    const route = useRoute();
    const statusBarH = ref(0);
    onMounted(() => {
      document.title = '推广服务';
      if (route.query.sub_index) {
        tab_index.value = Number(route.query.sub_index);
      }
      console.log('sub_index--------->', route.query.sub_index, tab_index.value);

      // 请求金币信息
      requestGoldInfo();

      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "onGetDeviceInfo",
        functionParams: {},
        callBack: e => {
          console.log('statusBarH---------', e.data.statusBarH);
          statusBarH.value = Number(e.data.statusBarH);
        }
      });
    });
    const goldNum = ref('');
    async function requestGoldInfo() {
      const {
        status,
        data
      } = await getGoldNum();
      if (status == 0) {
        goldNum.value = data.balance;
      }
    }
    function handleClickTab(index) {
      tab_index.value = index;

      // 获取当前路径和查询参数
      const currentPath = route.path;

      // 使用 router.push() 或 router.replace() 方法动态改变 URL 参数
      router.push({
        path: currentPath,
        // 保持当前路径不变
        query: {
          ...route.query,
          sub_index: index
        } // 更新 sub_index 参数
      });

      // switch (index) {
      //     case 0:
      //         {
      //             allListRef.value.handleRefreshAction();
      //         }
      //         break;
      //     case 1:
      //         {
      //             myListRef.value.handleRefreshAction();
      //         }
      //         break;
      //     default:
      //         break;
      // }
    }

    // 案例
    function handleExampleAction() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}/score/promotion/demo`,
        webFun: () => {
          router.push({
            path: `/score/promotion/demo`
          });
        }
      });
    }

    // 任务中心
    function handleTaskAction() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}/score/task/index`,
        webFun: () => {
          router.push({
            path: `/score/task/index`
          });
        }
      });
    }

    //离开页面
    function handleGoBack() {
      // eslint-disable-next-line
      graft.app({
        functionName: "closeController",
        functionParams: "",
        callBack: () => {},
        webFun: () => {
          window.history.go(-1);
        }
      });
    }

    //是否吸顶
    function handleStickyAction(is_fix) {
      isFix.value = is_fix ? 1 : 0;
    }
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_sticky = _resolveComponent("van-sticky");
      const _component_van_tab = _resolveComponent("van-tab");
      const _component_van_tabs = _resolveComponent("van-tabs");
      const _component_van_config_provider = _resolveComponent("van-config-provider");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!_unref(env).isWeixin() ? (_openBlock(), _createBlock(_component_van_sticky, {
        key: 0,
        onChange: handleStickyAction
      }, {
        default: _withCtx(() => [_createElementVNode("header", {
          class: _normalizeClass([{
            'headerAndroid': _unref(env).isModianAndroid()
          }, {
            'isFix': isFix.value
          }])
        }, [_createVNode(_component_van_image, {
          class: "back-btn",
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/nav_back_btn.png', 32),
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => handleGoBack(), ["stop"]))
        }, null, 8, ["src"]), _hoisted_2, _createElementVNode("div", {
          class: "rule-info",
          onClick: _cache[1] || (_cache[1] = _withModifiers($event => handleExampleAction(), ["stop"]))
        }, [_createVNode(_component_van_image, {
          class: "icon",
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/score_promotion_example_icon.png', 64)
        }, null, 8, ["src"]), _hoisted_3])], 2)]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_4)), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
        class: "gold-num",
        onClick: _cache[2] || (_cache[2] = _withModifiers($event => _ctx.handleGoldList(), ["stop"]))
      }, [_createElementVNode("span", null, _toDisplayString(goldNum.value), 1), _hoisted_8]), _createElementVNode("div", {
        class: "gold-cost",
        onClick: handleTaskAction
      }, [_hoisted_9, _createVNode(_component_van_image, {
        class: "arrow",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/score_task_arrow.png', 44)
      }, null, 8, ["src"])])])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_van_sticky, {
        "offset-top": _unref(env).isWeixin() == false ? statusBarH.value + 44 : 0 + 'px'
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabTitles, (item, index) => {
          return _createElementVNode("div", {
            class: _normalizeClass(['tab-item', {
              'selected': index == tab_index.value
            }]),
            key: index,
            onClick: _withModifiers($event => handleClickTab(index), ["stop"])
          }, [_createTextVNode(_toDisplayString(item.title) + " ", 1), index == tab_index.value ? (_openBlock(), _createElementBlock("div", _hoisted_13)) : _createCommentVNode("", true)], 10, _hoisted_12);
        }), 64))])]),
        _: 1
      }, 8, ["offset-top"]), _createVNode(_component_van_config_provider, {
        "theme-vars": _unref(tabStyle)
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tabs, {
          active: tab_index.value,
          "onUpdate:active": _cache[3] || (_cache[3] = $event => tab_index.value = $event),
          shrink: "",
          sticky: "",
          swipeable: "",
          "offset-top": _unref(env).isWeixin() == false ? 44 : 0 + 'px',
          onClickTab: _cache[4] || (_cache[4] = $event => _ctx.onClickTab(tab_index.value))
        }, {
          default: _withCtx(() => [_createVNode(_component_van_tab, {
            title: "推广服务"
          }, {
            default: _withCtx(() => [_createVNode(allList, {
              ref_key: "allListRef",
              ref: allListRef
            }, null, 512)]),
            _: 1
          }), _createVNode(_component_van_tab, {
            title: "我的推广"
          }, {
            default: _withCtx(() => [_createVNode(myList, {
              ref_key: "myListRef",
              ref: myListRef
            }, null, 512)]),
            _: 1
          })]),
          _: 1
        }, 8, ["active", "offset-top"])]),
        _: 1
      }, 8, ["theme-vars"])])])]);
    };
  }
};